import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';

interface PasswordChangeGuardProps {
  children: React.ReactNode;
}

const PasswordChangeGuard: React.FC<PasswordChangeGuardProps> = ({ children }) => {
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.user.user);
  
  useEffect(() => {
    // Force redirect if user requires password change
    if (user && user.requirePasswordChange) {
      const currentPath = window.location.pathname;
      // Check if not already on change-password page (including query params)
      if (!currentPath.startsWith('/change-password')) {
        console.log("User requires password change, redirecting to change-password page");
        navigate('/change-password', { replace: true });
      }
    }
  }, [user, navigate]);

  // Block rendering if user requires password change and not on change password page
  if (user && user.requirePasswordChange && !window.location.pathname.startsWith('/change-password')) {
    return null;
  }

  return <>{children}</>;
};

export default PasswordChangeGuard;
